import DataTable from '@/containers/data_table_ml/DataTable';
import './TablePage.less';
import React from 'react';

const TestPage = (props) => {
  const { val } = props || {};
  const s = val?.valueMap;
  let data = [];
  for (let key in s) {
    data.push({ name: key, value: s[key] });
  }

  const columns = [
    {
      title: '输出字段',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '输出项',
      dataIndex: 'value',
      key: 'value',
    },
  ];

  return (
    <DataTable
      border={true}
      className="demo-test"
      style={{ minWidth: '1547px', border: '1px solid #edf0f0' }}
      columns={columns}
      rowSelection={false}
      scroll={{ y: 'calc(100vh - 160px - 3rem)' }}
      dataSource={data}
      // loading={loading}
    />
  );
};
export default TestPage;
